import axios from 'axios';
import { installRefreshInterceptor, installForbiddenToastInterceptor } from '@bill/ui';

/**
 * Client API pour core-backend (auth, users, admin, audit, notifications)
 * Séparé de apiClient qui pointe vers bstock-backend (métier stock)
 */

const CORE_API_BASE_URL = import.meta.env.VITE_CORE_API_URL || 'http://localhost:44050/api';

export const coreApiClient = axios.create({
  baseURL: CORE_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Install the shared JWT auto-refresh interceptor from @bill/ui
// (request bearer token + 401 auto-refresh, shared with BStaff)
installRefreshInterceptor({ client: coreApiClient, coreApiUrl: CORE_API_BASE_URL });
installForbiddenToastInterceptor({ client: coreApiClient });

// Export l'URL de base pour les usages directs (SSE, refresh)
export { CORE_API_BASE_URL };
